<template>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @input="change"
          @changeFunction="changeFunction"
          @deleted="$emit('deleted',true)"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  },
  item: {
    default : null
  }
},
created() {
       this.itemLink =  `orders/${this.id}/purchases`;
      this.setLink = `orders/${this.id}/purchases`;
},
methods: {
    changeFunction(val) {},
    change(val) {
      console.log('222');
    },
 
  },
  data() {
    return {
      val: [],
      modalCreate: "purchase",
      fields: [
           {
              label: "Товар",
              key: "option",
              type: "select",
              modal: "option", 
              params: {shop_id: this.item.shop.id},
              selectKey: "display_name",
            },
           {
              label: "Количество",
              key: "quantity",
              type: "field",
              textType: "number", 
            },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_purchase",
      itemLink: "purchases",
      setLink: "purchases",
   columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        {
          key: "display_name",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена за 1 ед.",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "quantity",
          title: "Количество",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "price_total",
          title: "Общая стоимость",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
    
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
